import React from 'react'
import Thanks from '../Components/Thanks';
import "./HomeScreen.css";

export default function MapsPage() {
    return (
        <div>
            <Thanks/>
        </div>
    )
}
